export default __webpack_public_path__ + "static/media/img1.0867e4c0.png";